import { render, staticRenderFns } from "./linkeddocs.vue?vue&type=template&id=1202e26a"
import script from "./linkeddocs.vue?vue&type=script&lang=js"
export * from "./linkeddocs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports